import { computed } from 'vue';
import i18n, { EN, ZH, ZH_HK } from '@/locales';
import { useCommonData } from '@/hooks';

export const useAnalystCore = () => {
    const { getOrganizationName } = useCommonData();
    const translatedText = computed(() => {
        const localeText = {
            [ZH]: `上述公司和分析师已覆盖${getOrganizationName.value}。请注意这些公司和分析师并非受${getOrganizationName.value}委托。上述公司或分析师就${getOrganizationName.value}的业绩作出的任何意见、估计或预测，仅属个人意见，不代表${getOrganizationName.value}或其管理层的意见、估计或预测。${getOrganizationName.value}提及或传阅上述名单，并不暗示其认可或同意此类信息、结论或建议。`,
            [ZH_HK]: `上述公司和分析師已覆蓋${getOrganizationName.value}。請註意這些公司和分析師並非受${getOrganizationName.value}委托。上述公司或分析師就${getOrganizationName.value}的業績作出的任何意見、估計或預測，僅屬個人意見，不代表${getOrganizationName.value}或其管理層的意見、估計或預測。${getOrganizationName.value}提及或傳閱上述名單，並不暗示其認可或同意此類信息、結論或建議。`,
            [EN]: `${getOrganizationName.value} is followed by the analysts listed, which are not commissioned by ${getOrganizationName.value}. Please note that any opinions, estimates or forecasts regarding ${getOrganizationName.value}'s performance made by these analysts are theirs alone and do not represent opinions, forecasts or predictions of ${getOrganizationName.value} or its management. ${getOrganizationName.value} does not by its reference or distribution imply its endorsement of or concurrence with such information, conclusions or recommendations.`
        };
    
        return localeText[i18n.locale];
    });
    
    const statementText = computed(() => {
        const localeText = {
            [ZH]: `列表按首字母顺序列出，排名无先后之分。`,
            [ZH_HK]: `列表按首字母順序列出，排名無先後之分。`,
            [EN]: `In no particular order; sorted alphabetically.`
        };
        return localeText[i18n.locale];
    });
    return {
        translatedText,
        statementText
    }
}